import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  inject,
  isDevMode,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductsService } from 'src/app/services/products.service';
import { Observable, Subject, catchError, filter, forkJoin, fromEvent, map, of, takeUntil } from 'rxjs';
import { EAssetType, IAsset, IAssetDetailResponse } from 'src/app/models/products/asset';
import {
  OutputAssetVersionsByIdOutputAsset,
  OutputAssetVersionsByIdResponse,
} from 'src/app/models/output-assets/output-asset-versions-by-id';
import { AuthService } from 'src/app/services/auth.service';
import { Permission } from 'src/app/constants/permission.constant';
import { AssetsNavigateComponent } from './assets-navigate/assets-navigate.component';
import { cloneDeep, get, isEmpty } from 'lodash';
import { environment } from 'src/environments/environment';
import { IBoundingBox, IBoundingBoxPercentage, IDimensions } from 'src/app/models/boundingBox';
import { IComment } from 'src/app/models/comment';
import { UrlService } from 'src/app/services/url.service';
import { AssetsService } from 'src/app/services/assets.service';
import { AssetMetaDataResult, AssetDeleteResult, PinAssetResult } from 'src/app/models/assets/assets-result';
import { ValidationErrors } from 'src/app/models/validationErrors';
import { AlertService } from 'src/app/services/alert.service';
import { DeleteModalComponent } from 'src/app/components/shared/delete-modal/delete-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MetaData } from 'src/app/models/assetMetaData';
import { Clipboard } from '@angular/cdk/clipboard';
import { ClipboardService } from 'src/app/services/clipboard.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { CreateOutputsComponent } from 'src/app/components/home/output-assets/actions/create-outputs/create-outputs.component';
import { O } from '@angular/cdk/keycodes';
import { GenerateAutoPostDialogComponent } from 'src/app/components/home/products/actions/generate-auto-post-dialog/generate-auto-post-dialog.component';
import { SignalrService } from 'src/app/services/signalr.service';
import { SignalrGroup } from 'src/app/services/signalr-group';

@Component({
  selector: 'app-review-assets',
  templateUrl: './review-assets.component.html',
  styleUrls: ['./review-assets.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ReviewAssetsComponent implements OnInit, OnDestroy {
  public pageLink = '';
  @ViewChild('assetNavigate') assetNavigate!: AssetsNavigateComponent;
  @ViewChild('asset') asset!: ElementRef;
  @ViewChild('assetContainer') assetContainer!: ElementRef;
  private readonly destroyRef = inject(DestroyRef);
  private destroy$ = new Subject();
  private entryUrl?: string;
  isCompare = false;
  activeTab = 0;

  productId = '';
  organizationId = '';
  assetId = '';
  masterSuiteTouchAssetId = '';
  outputFormatId = '';
  outputAssetId = '';
  formulaScoped = false;
  activeKind: 'range' | 'ev' = 'range';
  assetType = 'output-asset';
  versionNumber: number = 0;
  currentAsset = '';
  compareAsset = '';
  compareAssetIndex: number = 0;
  assetData: any = [];
  allAssetData: any = [];
  label = '';
  title = '';
  isDownloadFileLoading = false;
  productTouchAssetId = '';
  activeAsset: any = {};
  selectIndex?: number;
  fullscreen: boolean = false;
  drawing: boolean = false;
  transparentBackground: boolean = false;
  propertiesView: boolean = false;
  Permission = Permission;
  loading: boolean = true;
  initialized: boolean = false;
  toggleExtraActions: boolean = false;
  labelView: boolean = false;
  invalidLabelRegion: boolean = false;
  // public imageLabelBoundingBoxPercentageResults: { [key: string]: IBoundingBoxPercentage } = {};
  public imageLabelBoundingBoxPercentage: IBoundingBoxPercentage = {
    top: '',
    left: '',
    width: '',
    height: '',
  };
  // public hideVideoSubjectBoundingBox: boolean = true;
  // public subjectBoundingBoxPercentage: IBoundingBoxPercentage = {
  //   top: '',
  //   left: '',
  //   width: '',
  //   height: '',
  // };
  // public imageLabelBoundingBoxPercentageResults: {
  //   id: string; label_bounding_box_percentage: IBoundingBoxPercentage;
  // }[]=[{id:'',label_bounding_box_percentage: { top: '', left: '',width: '', height: ''}}];

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: any) {
    this.fullscreen = false;
  }
  constructor(
    private productsService: ProductsService,
    private assetsService: AssetsService,
    private alertService: AlertService,
    public authService: AuthService,
    public clipboardService: ClipboardService,
    private clipboard: Clipboard,
    public urlService: UrlService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private signalrService: SignalrService,
  ) {
    const prev = this.router.getCurrentNavigation()?.previousNavigation;
    const prevUrl = prev?.finalUrl?.toString();
    const wasReview = prevUrl?.includes('/productTouchAsset/') ?? false;
    this.entryUrl = wasReview ? prev?.previousNavigation?.finalUrl?.toString() : prevUrl;

    this.route.params.subscribe((routeParams) => {
      const routedAssetType = routeParams['assetType'] as string | undefined;
      const routedId = routeParams['id'] as string | undefined;
      const dataAssetType = this.route.snapshot.data?.['assetType'] as string | undefined;
      const dataFormulaScoped = this.route.snapshot.data?.['formulaScoped'] === true;
      this.assetType = routedAssetType ?? dataAssetType ?? this.assetType;
      this.assetId = (routeParams['assetId'] as string) ?? this.assetId;
      this.formulaScoped = dataFormulaScoped && !!routedId;
      if (this.formulaScoped) {
        this.outputAssetId = routedId!;
        this.getOutputAssetById();
      }
    });
    this.route.queryParams.subscribe(() => {
      this.versionNumber = this.route.snapshot.queryParamMap.get('version') as unknown as number;
    });
  }

  filteredAssets() {
    this.assetData = cloneDeep(this.allAssetData);
    if (!isEmpty(this.assetData[this.activeTab])) {
      var idx = this.assetData.findIndex((x: IAsset) => x.index == this.versionNumber);
      if (idx > 0) {
        this.activeTab = idx;
      }
      const { reviewUri } = this.assetData[this.activeTab];
      this.currentAsset = reviewUri;
      if (isDevMode()) {
        console.log('[DEV] [ReviewAssetsComponent] this', this.currentAsset);
      }
      if (
        this.assetType === EAssetType.POST_ASSETS ||
        this.assetType === EAssetType.OUTPUT_ASSETS
      ) {
        this.productTouchAssetId = this.assetData[this.activeTab].productTouchAssetId;
      } else {
        this.productTouchAssetId = this.assetId;
      }
    }
  }

  ngOnInit(): void {
    this.productId = this.route.snapshot.paramMap.get('productId') as string;
    const resolvedAssetType = this.resolveAssetType();
    if (resolvedAssetType) {
      this.assetType = resolvedAssetType;
    }
    this.subscribeToSignalRUpdates();
  }

  private resolveAssetType(): string | null {
    return (
      this.route.snapshot.paramMap.get('assetType') ??
      (this.route.snapshot.data?.['assetType'] as string | undefined) ??
      null
    );
  }

  private subscribeToSignalRUpdates(): void {
    SignalrGroup.subscribe({
      destroyRef: this.destroyRef,
      data$: this.signalrService.postAssetsData.pipe(
        filter((data: any) => !isEmpty(data))
      ),
      onData: (data: any) => {
        const index = this.assetData.findIndex((asset: IAsset) => asset.id === data.id);
        if (index > -1 && data.contentExtracting !== undefined) {
          this.assetData[index].contentExtracting = data.contentExtracting;
        }
      },
    });

    SignalrGroup.subscribe({
      destroyRef: this.destroyRef,
      data$: this.signalrService.shootAssetsData.pipe(
        filter((data: any) => !isEmpty(data))
      ),
      onData: (data: any) => {
        const index = this.assetData.findIndex((asset: IAsset) => asset.id === data.id);
        if (index > -1 && data.contentExtracting !== undefined) {
          this.assetData[index].contentExtracting = data.contentExtracting;
        }
      },
    });
  }
  @ViewChild('layout') canvasRef: any;
  initialData(): void {
    this.loading = true;
    this.isCompare = false;
    this.activeTab = 0;
    if (this.formulaScoped) {
      this.outputAssetId = this.route.snapshot.paramMap.get('id') ?? '';
      this.getOutputAssetById();
      return;
    }
    this.assetId = this.route.snapshot.paramMap.get('assetId') as string;
    if (this.assetType == EAssetType.POST_ASSETS || this.assetType == EAssetType.AUTO_POST_ASSETS) {
      this.masterSuiteTouchAssetId = this.route.snapshot.paramMap.get(
        'masterSuiteTouchAssetId',
      ) as string;
    }
    if (this.assetType == EAssetType.OUTPUT_ASSETS) {
      this.masterSuiteTouchAssetId = this.route.snapshot.paramMap.get(
        'masterSuiteTouchAssetId',
      ) as string;
      this.outputFormatId = this.route.snapshot.paramMap.get('outputFormatId') as string;
    }
    this.getAssetDetails();
  }

  getAssetDetails() {
    this.productsService[
      this.assetType === EAssetType.SHOOT_ASSETS
        ? 'getShootAssetDetails'
        : this.assetType === EAssetType.POST_ASSETS
        ? 'getPostAssetDetails'
        : this.assetType === EAssetType.AUTO_POST_ASSETS
        ? 'getAutoPostAssetDetails'
        : 'getOutputAssetDetails'
    ](this.assetId, this.masterSuiteTouchAssetId, this.outputFormatId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          const assetDetail: IAssetDetailResponse =
            this.assetType === EAssetType.SHOOT_ASSETS ? data.shootAssets : data;
          this.allAssetData =
            assetDetail[
              this.assetType === EAssetType.SHOOT_ASSETS
                ? 'shootAssets'
                : this.assetType === EAssetType.POST_ASSETS
                ? 'postAssets'
                : this.assetType === EAssetType.AUTO_POST_ASSETS
                ? 'postAssets'
                : 'outputAssets'
            ];
          this.productId = assetDetail.productId;
          this.organizationId = assetDetail.organizationId ?? '';
          this.title = assetDetail.barcode! || assetDetail.reference!;
          this.filteredAssets();
          if (isDevMode()) {
            console.log('[DEV] [ReviewAssetsComponent] `this', `this.router.url: {this.router.url}`);
          }
          this.pageLink = this.updatePageLink();
          this.loading = false;
          this.initialized = true;
          if (isDevMode()) {
            console.log('[DEV] [ReviewAssetsComponent] new id');
          }

          if (isDevMode()) {
            console.log('[DEV] [ReviewAssetsComponent] `id: ${this', `id: ${this.assetData[this.activeTab].id}, type: ${this.assetType}`);
          }
        },
        error: () => {
          if (isDevMode()) {
            console.log('[DEV] [ReviewAssetsComponent] invalid asset id');
          }
          this.onBack();
        },
      });
  }
  getOutputAssetById(): void {
    if (!this.outputAssetId) return;
    this.loading = true;
    this.productsService
      .getOutputAssetById(this.outputAssetId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: OutputAssetVersionsByIdResponse) => {
          this.allAssetData = response.outputAssets.map((asset) =>
            this.mapOutputAssetToAsset(asset),
          );
          this.productId = response.product.id;
          this.title = response.product.barcode || response.product.reference;
          this.activeKind = response.context.kind === 'Ev' ? 'ev' : 'range';
          this.filteredAssets();
          this.pageLink = this.updatePageLink();
          this.loading = false;
          this.initialized = true;
          if (isDevMode()) {
            console.log(
              '[DEV] [ReviewAssetsComponent] output-asset versions loaded',
              this.allAssetData.length,
            );
          }
        },
        error: () => {
          if (isDevMode()) {
            console.log('[DEV] [ReviewAssetsComponent] output-asset fetch failed');
          }
          this.loading = false;
          this.onBack();
        },
      });
  }

  private mapOutputAssetToAsset(asset: OutputAssetVersionsByIdOutputAsset): any {
    return {
      id: asset.id,
      versionNumber: asset.version.number,
      index: asset.version.index,
      pinnedVersion: asset.version.pinned,
      postProcessedDate: asset.version.postProcessedAt,
      type: asset.type,
      reviewUri: asset.uris.review,
      rawUri: asset.uris.raw,
      thumbnailUri: asset.uris.thumbnail,
      postAssetId: asset.postAsset.id,
      productTouchAssetId: asset.postAsset.productTouchAssetId,
      masterSuiteTouchAssetId: asset.postAsset.masterSuiteTouchAssetId,
      postAssetVersionNumber: asset.postAsset.versionNumber,
      internalReviewState: asset.internalReview.state,
      internalReviewDate: asset.internalReview.at,
      internalReviewById: asset.internalReview.by.id,
      internalReviewByName: asset.internalReview.by.name,
      outputFormulaId: asset.provenance.outputFormulaId,
    };
  }

  public saveBoundingBoxPercentage(boundingBoxProportion: IBoundingBox | null) {
    if (isDevMode()) {
      console.log('[DEV] [ReviewAssetsComponent] boundingBoxProportion', boundingBoxProportion);
    }
    if (boundingBoxProportion == null) {
      this.invalidLabelRegion = true;
      return;
    } else {
      this.invalidLabelRegion = false;
      if (isDevMode()) {
        console.log('[DEV] [ReviewAssetsComponent] this', this.labelView);
      }
      if (isDevMode()) {
        console.log('[DEV] [ReviewAssetsComponent] boundingbox:');
      }
      this.imageLabelBoundingBoxPercentage = this.calculatePercentage(boundingBoxProportion);
    }
  }

  private retrieveAndCalculateLabelBoundingBoxPercentage(
    currentAssetId: string,
    assetType: string,
  ): Observable<IBoundingBoxPercentage> {
    if (isDevMode()) {
      console.log('[DEV] [ReviewAssetsComponent] `currentAssetId: ${currentAssetId}', `currentAssetId: ${currentAssetId}, assetType: ${assetType}`);
    }

    return this.assetsService.getAssetMetaData(currentAssetId, assetType).pipe(
      map((result: AssetMetaDataResult) => {
        const metaData = result.assetMetaData.metaData;
        if (isDevMode()) {
          console.log('[DEV] [ReviewAssetsComponent] result:');
        }
        if (isDevMode()) {
          console.log('[DEV] [ReviewAssetsComponent] result', result);
        }
        if (isDevMode()) {
          console.log('[DEV] [ReviewAssetsComponent] `metadata_l: ${metaData', `metadata_l: ${metaData.length}`);
        }
        const subjectFilterKeys: string[] = [
          'SubjectTop',
          'SubjectLeft',
          'SubjectWidth',
          'SubjectHeight',
        ];

        const subjectBoundingBoxResult = this.getSpecificMetadata(metaData, subjectFilterKeys);
        const subjectBoundingBoxProportion: IBoundingBox = {
          top: subjectBoundingBoxResult.SubjectTop,
          left: subjectBoundingBoxResult.SubjectLeft,
          width: subjectBoundingBoxResult.SubjectWidth,
          height: subjectBoundingBoxResult.SubjectHeight,
        };
        if (isDevMode()) {
          console.log('[DEV] [ReviewAssetsComponent] subjectboundingbox: ');
        }
        if (isDevMode()) {
          console.log('[DEV] [ReviewAssetsComponent] subjectBoundingBoxProportion', subjectBoundingBoxProportion);
        }

        // const imageDimensionFilterKeys: string[] = [
        //   'ImageWidth',
        //   'ImageHeight',
        // ];
        // const imageDimensionsResult = this.getSpecificMetadata(
        //   metaData,
        //   imageDimensionFilterKeys
        // );
        // const imageDimensions: IDimensions = {
        //   width: imageDimensionsResult.ImageWidth,
        //   height: imageDimensionsResult.ImageHeight,
        // };
        return subjectBoundingBoxProportion;
      }),
      map((subjectBoundingBoxProportion) => {
        const subjectBoundingBoxPercentage: IBoundingBoxPercentage = this.calculatePercentage(
          subjectBoundingBoxProportion,
        );

        if (isDevMode()) {
          console.log('[DEV] [ReviewAssetsComponent] subjectboundingboxpercentage: ');
        }
        if (isDevMode()) {
          console.log('[DEV] [ReviewAssetsComponent] subjectBoundingBoxPercentage', subjectBoundingBoxPercentage);
        }

        return subjectBoundingBoxPercentage;
      }),
      catchError((error) => {
        console.error('Error occurred:', error);
        const emptyResult: IBoundingBoxPercentage = {
          top: '',
          left: '',
          width: '',
          height: '',
        };
        return of(emptyResult);
      }),
    );
  }

  private getSpecificMetadata(metaData: MetaData[], filterList: string[]): any {
    const resultArray: MetaData[] = metaData.filter((data: MetaData) =>
      filterList.includes(data.key),
    );
    const resultWithIntValues = resultArray.map((metaData: any) => {
      metaData.value = parseFloat(metaData.value);
      return metaData;
    });
    const resultObject: any = resultWithIntValues.reduce((acc: any, item) => {
      acc[item.key] = item.value;
      return acc;
    }, {});
    return resultObject;
  }

  private calculatePercentage(subjectBoundingBoxProportion: IBoundingBox): IBoundingBoxPercentage {
    const subjectBoundingBoxPercentage: IBoundingBoxPercentage = {
      top: `${subjectBoundingBoxProportion.top * 100}%`,
      left: `${subjectBoundingBoxProportion.left * 100}%`,
      width: `${subjectBoundingBoxProportion.width * 100}%`,
      height: `${subjectBoundingBoxProportion.height * 100}%`,
    };

    return subjectBoundingBoxPercentage;
  }

  private calculateBoundingBoxPercentage(
    subjectBoundingBox: IBoundingBox,
    objectSize: IDimensions,
  ): IBoundingBoxPercentage {
    const res = subjectBoundingBox.top / objectSize.height;
    if (isDevMode()) {
      console.log('[DEV] [ReviewAssetsComponent] res', res);
    }

    const subjectBoundingBoxPercentage: IBoundingBoxPercentage = {
      top: `${(subjectBoundingBox.top / objectSize.height) * 100}%`,
      left: `${(subjectBoundingBox.left / objectSize.width) * 100}%`,
      width: `${(subjectBoundingBox.width / objectSize.width) * 100}%`,
      height: `${(subjectBoundingBox.height / objectSize.height) * 100}%`,
    };

    return subjectBoundingBoxPercentage;
  }

  reviewOutputAsset(id: string, review: string) {
    this.productsService.reviewOutputAsset(id, review).subscribe((res) => {
      this.assetData[0].internalReviewState = review;
    });
  }

  onKindChange(kind: 'range' | 'ev'): void {
    this.activeKind = kind;
  }

  compareChange(value: boolean, compareAsset: string) {
    this.isCompare = value;
    this.compareAsset = compareAsset || 'assets/image-placeholder.jpg';
  }

  onChangeVersion(index: number) {
    this.activeTab = index;
    if (index === 0) {
      this.isCompare = false;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { version: null },
        queryParamsHandling: 'merge',
      });
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { version: this.assetData[index].index },
        queryParamsHandling: 'merge',
      });
      this.isCompare = false;
      this.compareAsset = this.assetData[index].reviewUri;
      this.compareAssetIndex = index;
    }
  }

  openParentAsset(isPostAsset: boolean) {
    // clear Params
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { version: null },
      queryParamsHandling: 'merge',
    });

    var route = isPostAsset
      ? this.router.url.split('?')[0].replace(this.assetType, EAssetType.SHOOT_ASSETS)
      : this.router.url.split('outputFormat')[0].concat(EAssetType.POST_ASSETS);

    const url = this.router.serializeUrl(
      this.router.createUrlTree([route], {
        queryParams: {
          version: isPostAsset
            ? this.assetData[this.activeTab].shootAssetVersionNumber
            : this.assetData[this.activeTab].postAssetVersionNumber,
        },
        queryParamsHandling: 'merge',
      }),
    );
    window.open(url, '_blank');
  }

  onLoadedNavigate(value: any) {
    if (isDevMode()) {
      console.log('[DEV] [ReviewAssetsComponent] onloadednavigate', value);
    }
    this.label = value.label;
    this.selectIndex = value.selectIndex;
    this.activeAsset = value.activeRecord;
    this.initialData();
  }

  onOpenVersion(data: any) {
    const assetType = this.resolveAssetType();
    const idx = this.assetData.findIndex(
      (asset: IAsset) =>
        asset.id === data[assetType === EAssetType.SHOOT_ASSETS ? 'shootAssetId' : 'postAssetId'],
    );
    if (idx > -1) {
      this.onChangeVersion(idx);
    }
  }

  onReload() {
    this.getAssetDetails();
    this.assetNavigate.getData();
  }

  downLoadImage(imageUri: string) {
    const tmp = imageUri.split('?')[0].split('/');
    const fileName = tmp[tmp.length - 1].split('.');
    var download =
      this.assetType != 'output-asset'
        ? `${fileName[0]}-version-${this.assetData[this.activeTab].versionNumber}.${fileName[1]}`
        : `${fileName[0]}.${fileName[1]}`;
    if (isDevMode()) {
      console.log('[DEV] [ReviewAssetsComponent] this', this.assetType);
    }
    if (isDevMode()) {
      console.log('[DEV] [ReviewAssetsComponent] this', this.selectIndex);
    }
    if (
      this.activeTab == 0 &&
      (this.assetType == 'post-asset' || this.assetType == 'auto-post-asset') &&
      this.selectIndex != undefined
    ) {
      download = `${fileName[0]}_${this.selectIndex / 1000 + 1}.${fileName[1]}`;
    }

    this.productsService.downloadSingleImage(imageUri.split('//')[1]).subscribe((res) => {
      const blod: Blob = res.body as Blob;
      const a = document.createElement('a');

      const fileData = window.URL.createObjectURL(blod);
      a.href = fileData;
      a.download = download;
      a.click();
      window.URL.revokeObjectURL(fileData);
    });
  }

  getLinkImage(source: string) {
    return ProductsService.getLinkImage(source);
  }

  box: IBoundingBox | null = null;
  initalTop: number = 0;
  initalLeft: number = 0;
  finalBox: IBoundingBox | null = null;
  drawn: boolean = false;
  activeVersionId: string = '';

  toggleDrawing() {
    this.finalBox = null;
    this.activeVersionId = !this.drawing ? this.assetData[0].id : '';
    this.drawing = !this.drawing;
  }

  startDrawing(evt: MouseEvent) {
    this.drawn = false;
    evt.preventDefault();
    this.initalTop = evt.offsetY / this.asset.nativeElement.clientHeight;
    this.initalLeft = evt.offsetX / this.asset.nativeElement.clientWidth;
    this.box = {
      left: evt.offsetX,
      top: evt.offsetY,
      width: 0,
      height: 0,
    };
  }

  keepDrawing(evt: MouseEvent) {
    if (this.box) {
      var w = evt.offsetX / this.asset.nativeElement.clientWidth - this.initalLeft;
      var h = evt.offsetY / this.asset.nativeElement.clientHeight - this.initalTop;
      this.box.width = Math.abs(w);
      this.box.height = Math.abs(h);

      this.box.top = h < 0 ? this.initalTop - this.box.height : this.initalTop;
      this.box.left = w < 0 ? this.initalLeft - this.box.width : this.initalLeft;
    }
  }

  stopDrawing() {
    this.finalBox = this.box;
    this.box = null;
    this.drawn = true;
  }

  checkMargin(x: boolean): string {
    if (!this.assetContainer || !this.asset) {
      return '0px';
    }

    if (x) {
      return (
        (this.assetContainer.nativeElement.clientWidth - this.asset.nativeElement.clientWidth) / 2 +
        'px'
      );
    } else {
      return (
        (this.assetContainer.nativeElement.clientHeight - this.asset.nativeElement.clientHeight) /
          2 +
        'px'
      );
    }
  }

  commentHover(comment: IComment) {
    if (!this.drawing) {
      this.finalBox = comment == null ? null : comment.boundingBoxReference!;
      this.drawn = this.finalBox == null ? false : true;
      this.activeVersionId =
        comment == null
          ? ''
          : this.assetType == EAssetType.POST_ASSETS
          ? comment.postAssetId
          : comment.shootAssetId;
    }
  }

  pinAssetVersion(id: string, state: boolean) {
    this.assetsService.pinAsset(id, this.assetType, state).subscribe((result: PinAssetResult) => {
      if (isDevMode()) {
        console.log('[DEV] [ReviewAssetsComponent] res', result);
      }
      const foundIdx = this.assetData.findIndex((el: IAsset) => el.id == id);
      const elm = this.assetData[foundIdx];
      elm.pinnedVersion = state;
      if (state) {
        this.assetData.splice(foundIdx, 1)[0];
        this.assetData.splice(0, 0, elm);
        this.currentAsset = this.assetData[0].reviewUri;
        this.onChangeVersion(0);
      } else {
        this.initialData();
      }
    });
  }

  deleteAssetDialog(id: string) {
    const dialogRef = this.dialog.open(DeleteModalComponent, {
      data: {
        header: `Delete Version ${this.assetData[this.activeTab].versionNumber}`,
        message: `Are you sure you want to delete this ${this.assetType}`,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.deleteAsset(id);
      }
    });
  }

  deleteAsset(id: string) {
    this.assetsService.deleteAsset(id, this.assetType).subscribe({
      next: (result: AssetDeleteResult) => {
        if (isDevMode()) {
          console.log('[DEV] [ReviewAssetsComponent] result', result);
        }
        const foundIdx = this.assetData.findIndex((el: IAsset) => el.id == id);
        this.assetData.splice(foundIdx, 1);
        this.alertService.successToast(`${this.assetType} Deleted`);
        this.onChangeVersion(this.activeTab);
      },
      error: (error) => {
        if (error.status === 422) {
          error.error.validationErrors.forEach((err: ValidationErrors) => {
            this.alertService.errorToast(err.message);
          });
        }
      },
    });
  }

  generateOutputAssets() {
    this.dialog.open(CreateOutputsComponent, {
      data: {
        organizationId: this.organizationId,
        isBatch: false,
        productIds: this.productId ? [this.productId] : [],
        postAssetIds: [this.assetData[this.activeTab].id],
      },
    });
  }

  generateAutoPostAsset(shootAssetId: string) {
    this.dialog.open(GenerateAutoPostDialogComponent, {
      data: {
        shootAssetId: shootAssetId,
      },
    });
  }

  background(): string {
    if (this.transparentBackground) return "url('assets/transparent-background.png')";
    return '';
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onBack() {
    if (this.entryUrl) {
      this.router.navigateByUrl(this.entryUrl);
      return;
    }
    const batchId = this.route.snapshot.paramMap.get('batchId');
    const productId = this.route.snapshot.paramMap.get('productId');
    this.router.navigate(['batches', batchId, 'products', productId]);
  }

  updatePageLink() {
    const identifier: string = this.title;
    const touchNameAndAngleLabel: string = this.label;
    const pageLink = `${identifier} - ${touchNameAndAngleLabel}`;

    return pageLink;
  }

  private isHoveringTrigger = false;
  private isHoveringMenu = false;
  private closeTimeout: any;

  handleMouseEnter(area: 'trigger' | 'menu', trigger: MatMenuTrigger) {
    if (area === 'trigger') this.isHoveringTrigger = true;
    if (area === 'menu') this.isHoveringMenu = true;
    if (isDevMode()) {
      console.log('[DEV] [ReviewAssetsComponent] trigger', trigger);
    }
    clearTimeout(this.closeTimeout);

    // Only open the menu if it's not already open
    if (!trigger.menuOpen) {
      trigger.openMenu();
    }
  }

  handleMouseLeave(area: 'trigger' | 'menu', trigger: MatMenuTrigger) {
    if (isDevMode()) {
      console.log('[DEV] [ReviewAssetsComponent] trigger', trigger);
    }
    if (area === 'trigger') this.isHoveringTrigger = false;
    if (area === 'menu') this.isHoveringMenu = false;

    this.closeTimeout = setTimeout(() => {
      if (!this.isHoveringTrigger && !this.isHoveringMenu) {
        trigger.closeMenu();
      }
    }, 300); // delay before closing
  }
}
